import React from "react";
import { BookOpenIcon, MessageCircleHeartIcon, SproutIcon } from "lucide-react";
import { OfferLink } from "./OfferLink";
import { SectionHeading } from "./SectionHeading";
import { solutionBenefits } from "../data/landing";
const icons = [BookOpenIcon, MessageCircleHeartIcon, SproutIcon];
const tones: Record<string, {
  tile: string;
  icon: string;
}> = {
  royal: {
    tile: "bg-royal-light",
    icon: "bg-royal text-white"
  },
  rosy: {
    tile: "bg-rosy-light",
    icon: "bg-rosy text-white"
  },
  leaf: {
    tile: "bg-leaf-light",
    icon: "bg-leaf text-white"
  }
};
export function SolutionSection() {
  return <section className="bg-ivory" data-id="element-244" data-mp="aunnsxdlbvfa">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-245" data-mp="atw5go907u6y">
        <SectionHeading title={<>
              De petites paraboles pour faire grandir leur foi…{" "}
              <span className="text-tangerine" data-id="element-247" data-mp="kt3ex0cmb4os">et renforcer vos liens.</span>
            </>} subtitle="Découvrez une collection de plus de 50 paraboles chrétiennes illustrées, imaginées pour éveiller la curiosité des enfants et ouvrir des conversations sur les valeurs de la foi." data-id="element-246" data-mp="5v1a6mtuod5y" />

        <ul className="mt-12 grid gap-5 md:mt-16 md:grid-cols-3 md:gap-6" data-id="element-248" data-mp="3b9yzivlafdi5">
          {solutionBenefits.map((benefit, i) => {
          const Icon = icons[i];
          const tone = tones[benefit.tone];
          return <li key={benefit.title} className={`rounded-[2rem] px-6 pb-8 pt-7 text-center ${tone.tile}`} data-id="element-249" data-mp="3p9hsui9fwkae" data-mpi={i}>
                <span className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ring-4 ring-white ${tone.icon}`} data-id="element-250" data-mp="3u7044faxjblk">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-251" data-mp="6vqovi52pg1s" />
                </span>
                <h3 className="mt-5 font-display text-2xl font-bold text-royal" data-id="element-252" data-mp="bv3nt197ydkq">
                  {benefit.title}
                </h3>
                <p className="mt-2 leading-relaxed text-cocoa" data-id="element-253" data-mp="guganm03bknb">{benefit.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-12 flex justify-center" data-id="element-254" data-mp="2cugml84abird">
          <OfferLink variant="outline" data-id="element-255" data-mp="27yro784047wn">Voir l’offre complète</OfferLink>
        </div>
      </div>
    </section>;
}